export default [
    {
        path: "/pallets/dashboard",
        name: "pallets-dashboard",
        component: () => import("@/views/modules/pallets/dashboard"),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Pallets Dashboard",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Pallets" }
            ]
        }
    },



    {
        path: "/pallets/branch-transactions/:id",
        name: "pallets-branch-transactions",
        component: () => import("@/views/modules/pallets/branchTransactions"),
        props: true,
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Pallets: Branch Transactions",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Pallets", to: { name: "pallets-dashboard" } },
                { text: "Branch Transactions" }
            ]
        }
    },

    {
        path: "/pallets/supplier-transactions/:id",
        name: "pallets-supplier-transactions",
        component: () => import("@/views/modules/pallets/supplierTransactions"),
        props: true,
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Pallets: Supplier Recon",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Pallets", to: { name: "pallets-dashboard" } },
                { text: "Supplier Recon" }
            ]
        }
    },

    {
        path: "/pallets/adjustments",
        name: "pallets-adjustments",
        component: () => import("@/views/modules/pallets/adjustments"),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Pallet Adjustments",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Pallets", to: { name: "pallets-dashboard" } },
                { text: "Adjustments" }
            ]
        },
        children: [
            {
                path: "/pallets/adjustments/create",
                name: "pallets-adjustments-create",
                component: () =>
                    import("@/views/modules/pallets/adjustmentCreate"),
                meta: {
                    sidebarToggle: true,
                    requiresAuth: true,
                    layout: "app",
                    title: "Adjustment Create",
                    breadcrumb: [
                        { text: "Home", to: { name: "home" } },
                        {
                            text: "Pallet Adjustments",
                            to: { name: "pallets-adjustments" }
                        },
                        { text: "Create" }
                    ]
                }
            }
        ]
    },

    {
        path: "/pallets/movements",
        name: "pallets-movements",
        component: () => import("@/views/modules/pallets/movements"),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Pallets Movements",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Pallets", to: { name: "pallets-dashboard" } },
                { text: "Movements" }
            ]
        },
        children: [
            {
                path: "/pallets/movements/create",
                name: "pallets-movements-create",
                component: () =>
                    import("@/views/modules/pallets/movementCreate"),
                meta: {
                    sidebarToggle: true,
                    requiresAuth: true,
                    layout: "app",
                    title: "Movement Create",
                    breadcrumb: [
                        { text: "Home", to: { name: "home" } },
                        {
                            text: "Pallet Movements",
                            to: { name: "pallets-movements" }
                        },
                        { text: "Create" }
                    ]
                }
            },
            {
                path: "/pallets/movements/:id/received",
                name: "pallets-movements-received",
                component: () =>
                    import("@/views/modules/pallets/movementReceived"),
                props: true,
                meta: {
                    sidebarToggle: true,
                    requiresAuth: true,
                    layout: "app",
                    title: "Movement Received",
                    breadcrumb: [
                        { text: "Home", to: { name: "home" } },
                        {
                            text: "Pallet Movements",
                            to: { name: "pallets-movements" }
                        },
                        { text: "Received" }
                    ]
                }
            }
        ]
    }
];
